(function(){
    'use strict'

    angular
    .module('app.empresasFumigadoras')
    .controller('empresasFumigadoras.EditPiloto', EditPiloto);

    EditPiloto.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function EditPiloto($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiEFP = 'api/Empresas-Fumigadoras/Pilotos'
        const companiaId = UserInfoService.getCompaniaId();

        let vm = this;

        vm.data = {
            pilotoId: 0
        };

       
        vm.empresaFumigadoraId = $routeParams.empresaFumigadora ? $routeParams.empresaFumigadora : 0;
        vm.id = 0; //$routeParams.id ? $routeParams.id : 0;
        vm.pilotos = [];

        vm.data.empresaFumigadoraId = vm.empresaFumigadoraId;
        vm.title = 'Detalle EF: ' + vm.empresaFumigadoraId;

        const promisePilotos = getComboData(vm.pilotos, 'api/Pilotos', [companiaId], 'Error al obtener los pilotos.');
        
        get();

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function get(){

            $q.all([promisePilotos])
            .then(function(){
                if(vm.id != 0){
                    ApiBaseService.remoteController = apiEFP;
                    var promise = ApiBaseService.getAll([companiaId, vm.empresaFumigadoraId, vm.id]);
    
                    promise
                    .then(function(data){
                        vm.data = data;
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al obtener los datos: ' + error.data.Message);
                        break;
                }
            }); 

        };

        function doFormValidations()
        {
            validateSelectProperty('pilotoId');
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function create() {
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiEFP;
            var promise = ApiBaseService.save(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro creado con éxito.');
                clearData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                    case 400:
                        logger.warning('El registro ya existe!');
                        break;                    
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiEFP;
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/empresas-fumigadoras');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                    case 400:
                        logger.warning('El registro ya existe!');
                        break;
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                pilotoId: 0
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function validateSelectProperty(property){
            if(vm.data[property] == 0){
                $scope.dataForm[property].$setValidity("different", false);
            }
            else{
                $scope.dataForm[property].$setValidity("different", true);
            }
        };

        vm.onSelectChanged = function(property){
            validateSelectProperty(property);
        };

    }
})();